export const UI_TOGGLE_CART_MODAL = 'UI_TOGGLE_CART_MODAL';
export const UI_SET_BREADCRUMBS = 'UI_SET_BREADCRUMBS';
export const UI_SET_SHIPPING = 'UI_SET_SHIPPING';
export const UI_SET_REFRESH_CART = 'UI_SET_REFRESH_CART';
export const UI_SET_COUNTRY = "UI_SET_COUNTRY";
export const UI_SET_TAX_METHOD = "UI_SET_TAX_METHOD";
export const UI_TOGGlE_CUSTOM_QUOTE_MODAL = 'UI_TOGGlE_CUSTOM_QUOTE_MODAL';
export const UI_TOGGlE_COOKIE_MODAL = 'UI_TOGGlE_COOKIE_MODAL';
export const UI_TOGGLE_FREE_SAMPLE_MODAL = 'UI_TOGGLE_FREE_SAMPLE_MODAL';
export const UI_TOGGLE_POUCH_QUOTATION_MODAL = 'UI_TOGGLE_POUCH_QUOTATION_MODAL';